/** Most ids one by-ids call accepts. */
export const WORK_ITEM_BY_IDS_MAX = 100;
//# sourceMappingURL=WorkItemSummary.js.map